import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from '@decisiv/ui-components/lib/components/Typography';
import CircleF from '@decisiv/iconix/lib/components/CircleF';
import { badgeColorForAlert } from 'utils/Alerts';
import LinkOrLabel from '../LinkOrLabel';
import { SeverityCount } from './styles';

const getCountText = (loading, count) => {
  if (loading) return '';
  return count == null ? '―' : count;
};

export default function SeverityItem({ severity, count, loading, to, text }) {
  return (
    <>
      <H3 weight="regular">
        <CircleF color={badgeColorForAlert({ severity })} />
        <SeverityCount>{getCountText(loading, count)}</SeverityCount>
      </H3>
      <LinkOrLabel count={count} to={to} text={text} />
    </>
  );
}

SeverityItem.propTypes = {
  severity: PropTypes.string.isRequired,
  count: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

SeverityItem.defaultProps = {
  count: null,
};
